module.exports = __webpack_public_path__ + "img/Reclutamiento-seleccion.2b05d203.png";